<template>
  <v-row justify="center">
    <Confirm ref="confirmaGrabar" :label="$t('listaesperapresentaproblemas')" :cuerpo="problemas_grabar_cita" :label_aceptar="$t('grabar')" icon_aceptar="save" color_aceptar="primary" @confirm="grabar(true);" />
    <Confirm ref="confirmaEliminar" :label="$t('estaseguroeliminarlistaespera')"  :label_aceptar="$t('eliminar')" icon_aceptar="delete" color_aceptar="error" @confirm="eliminar2" />
    <v-dialog persistent max-width="500" v-model="visible">
      <v-card>
        <v-card-title class="cabeceraModal">
          <v-row>
            <v-col v-if="es_insert" cols="2"><v-icon left large>person_add</v-icon></v-col>
            <v-col v-if="es_insert">{{$t('nuevaanotacion')}}</v-col>
            <v-col v-if="es_update" cols="2"><v-icon left large>assignment_ind</v-icon></v-col>
            <v-col v-if="es_update">{{$t('edicionlistaespera')}}</v-col>
          </v-row>
        </v-card-title>
          
        <v-card-text>
          <v-form v-model='formValid' ref='form' onsubmit='return false' >
            <v-row>
              <!--AGENDA-->
              <v-col cols="6" >
                   <v-autocomplete v-model="rec.agendaDef" :rules="[rules.agendaDef]" ref="agendaDef" id="agendaDef" :items="lista_agendas" return-object  item-text="nombre" 
                       :label="'* '+$t('agenda')" class="autocompleto" required dense :no-data-text="$t('noexisteningunaagenda')"/>
              </v-col>
              <v-col cols="6" class="margintop_13">
                <ControlFecha :width="200" :label="'* '+$t('fechasolicitud')" v-model="rec.fecha" :rules="[rules.fecha]" :clearable="false" class="fecha ml-2" :mostrar_icono="sesion.ancho_pantalla>=350"  />
              </v-col>
            </v-row>

            <v-row>
            <v-col cols="10" class="margintop_30">
                 <ControlAutoComplete  v-model="rec.persona" :error-messages="mensaje_persona" @focus="persona_foco=true" @change="persona_change" :items="sesion.personas" :getText="nombreYapellidos" :label="'* '+$t('persona')" 
                     class="autocompleto"  dense :no-data-text="$t('noexisteningunapersona')" :abierto="visible"/>
            </v-col>
              <v-col cols="1" class="margintop_5" v-if="tienePermiso('PER_GESTIONPACIENTES_CT') && rec.persona">
                 <v-icon class="mr-4" color="blue" @click="editar_persona">contact_phone</v-icon>
              </v-col>
              <PersonaEdit ref="personaEdit" v-model="persona_nueva" @input="persona_nueva_change" />
              <v-col cols="1" class="margintop_5" v-if="es_insert"><v-icon class="mr-4" color="orange" @click="persona_anadir_click">person_add</v-icon></v-col>
            </v-row>

            <v-row>
            <v-col cols="6" v-if="this.sesion.es_medico()" class="margintop_30"><v-autocomplete v-model="rec.acto" :clearable="true"  :label="this.$i18n.t('acto')"  @focus="acto_foco=true" :items="actos" return-object item-text="nombre"  
                         class="autocompleto" required  dense :no-data-text="$t('noexisteningunacto')"/>
            </v-col>
            <v-col cols="5" class="margintop_20">
            <v-select v-model="rec.urgencia" :items="urgencias" item-value="cod" :label="'* '+$t('urgencia')" >
                <template v-slot:selection="{ item }">
                    <img :src="require('@/assets/'+item.image)" class="mr-2">{{ item.texto }}
                </template>
                <template v-slot:item="{ item }">
                    <img :src="require('@/assets/'+item.image)" class="mr-2">{{ item.texto }}
                </template>
            </v-select>
            </v-col>


            </v-row>

            <v-row> 
              <v-col cols="12" class="margintop_13">
                <v-textarea v-model="rec.descripcion" outlined rows="1" :label="$t('datosadicionales')" />
              </v-col>
            </v-row>


             
          </v-form>

        </v-card-text>
        <v-card-actions>
             <v-btn color="primary" @click="grabar" :disabled="!formValid"><v-icon class="mr-4">save</v-icon>{{$t('grabar')}}</v-btn>
             <v-btn v-if="es_update" color="error" @click="eliminar" :class="{'ml-5':sesion.ancho_pantalla>=500}" small ><v-icon >delete</v-icon>{{$t('borrar')}}</v-btn>
             <v-btn color="gray" @click="cerrar" class="ml-8"><v-icon color="red" class="mr-4" small>arrow_back_ios</v-icon>{{$t('cancelar')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

import {mapState, mapMutations} from 'vuex';
import Confirm from '@/components/Confirm.vue';
import ControlAutoComplete from '@/components/ControlAutoComplete.vue';
import ControlFecha from '@/components/ControlFecha.vue';
import PersonaEdit from '@/components/PersonaEdit.vue';
import {call_url, date_to_char, getActos, getParametro, getPersonas, ListaEspera, now, Persona, tienePermiso} from '@/library/misFunciones.js';

export default {
    name: 'ListaEsperaEdit',   
  components: { Confirm, ControlAutoComplete, ControlFecha, PersonaEdit },

    computed: {
        ...mapState(['sesion']),
        agenda() { return this.rec.agendaDef; },
        noVacio() {
            return true;
        },
        lista_agendas() {return this.sesion.agendas.filter( (agenda) => agenda.tipo==="S" || agenda.especialidad );},
        mensaje_persona(){
          if (!this.rec.persona ) {
            return this.$i18n.t('seleccionepersona');
          }
          return "";
        },        
        nueva_listaEspera() {return this.sesion.nueva_listaEspera},

    },

    props:{
      value: ListaEspera,
    },

    data() {
        return {
            visible: false,
            es_insert: false,
            es_update: false,
            //es_delete: false,
            actos: [],
            persona_nueva: null,
            rec: {},
            selected: undefined,
            formValid: false,
            problemas_grabar_cita: '',
            urgencias:[{cod:'N',texto:this.$i18n.t('nourgente'),image:'alertaVerde2.png'},{cod:'A',texto:this.$i18n.t('algourgente'),image:'alertaNaranja2.png'},{cod:'M',texto:this.$i18n.t('muyurgente'),image:'alertaRoja2.png'}],
            rules: {
                agendaDef: v => !!v || this.$t('seleccioneagenda'),
                fecha: v => v || this.$i18n.t('fechaincorrecta'),
                fecha: v => v || this.$i18n.t('fechaincorrecta'),
            },

        }
    },
    methods: {
        getParametro,
        getActos,
        getPersonas,
        tienePermiso,
        ...mapMutations(['mostrarLoading','ocultarLoading','mostrarError','mostrarMensaje']),

        async editar(cod){
          try{
            this.mostrarLoading(this.$i18n.t('leyendodatos')+'...');
            this.getPersonas();
            const data = await call_url("getListaEspera.php",{"cod":cod});
            if (data.resul==="OK") {
                // console.log("datos leidos",data.listaEspera);
                this.rec = data.listaEspera;
                this.visible = true;
                this.es_insert = false;
                this.es_update = true
                setTimeout(this.foco,100);                
            }
            else this.mostrarError(data.mensaje);

          }
          catch(error) {
            console.log(error);
            this.mostrarError(error.messaje);
          }
          finally {
            this.ocultarLoading();
          }

        },

        foco() {
           this.$refs.agendaDef.focus();
           this.$refs.form.resetValidation();
        } ,
        async nuevo(agendaDef) {
          this.getPersonas();
          this.rec = {cod:null, agendaDef:null, fecha:date_to_char(now(),"yyyy-mm-dd"), persona:null, acto:null, urgencia:'N', descripcion:''},
          this.visible = true;
          this.es_insert = true;
          this.es_update = false;
          setTimeout(this.foco,100);
        },
        async grabar(confirmacion){ //confirmacion:indica si estamos llamando desde la pantalla de confirmacion en cuyo caso tengo que incluir en los datos confirmacion=SI
          try{
            this.mostrarLoading(this.$i18n.t('grabando')+'...');
            if (!confirmacion.target && confirmacion) this.rec.confirmacion="SI";
            // console.log("grabar",this.rec)
            const data = await call_url("grabaListaEspera.php",this.rec);
            if (data.resul==="OK") {
              this.mostrarMensaje(this.$i18n.t('listaesperagrabadacorrectamente'));
              //this.sesion.ultima_lectura_listas_espera = 0;
            //   console.log("grabar",data)
              this.$emit('input',new ListaEspera(data.listaEspera));
              this.visible = false;
            }
            else if (data.resul==="WARN") {
              this.problemas_grabar_cita = data.mensaje;
              this.$refs.confirmaGrabar.abrir();
            }
            else this.mostrarError(data.mensaje);
          }
          catch(error) {
            console.log(error);
            this.mostrarError(error.response.data);
          }
          finally {
            this.ocultarLoading();
          }

        },
        cerrar(){
            this.visible = false;
        },
        

        eliminar(){
          try {
            this.$refs.confirmaEliminar.abrir();
          }
          catch(ex) {
            this.mostrarError(ex.message);
          }
        },
        async eliminar2(){
          try{
            
            this.mostrarLoading(this.$i18n.t('eliminando')+'...');
            const data = await call_url("eliminaListaEspera.php",this.rec.cod);
            if (data.resul==="OK") {
              this.visible = false;
              this.mostrarMensaje(this.$i18n.t('listaesperaeliminada'))
            //   this.$emit('change')
            this.$emit('input',null);
            }
            else {
              this.mostrarError(data.mensaje);
            }
            
          }
          catch(ex) {
            console.log(ex);
            //this.mostrarError(error.message);
          }
          finally {
            this.ocultarLoading();
          }

        },


        nombreYapellidos(persona) {
          // console.log("nombreYapellidos:persona",persona)
          if (persona===null)
            return "";
          else {
            if (this.mostrar_seudonimo && persona.seudonimo)//(getParametro("seudonimoEnAgenda")==="1")
               return persona.seudonimo;
            else 
               return persona.nombre+" "+persona.apellidos;

          }
        },
        persona_anadir_click(){
        //   let agenda=null;
        //   if (getParametro('citaVariasAgendas')=='S') {
        //     if (this.rec.agendas && this.rec.agendas.length>0) agenda = this.rec.agendas[0];
        //   }
        //   else agenda = this.rec.agenda
        //   this.$refs.personaEdit.nuevo(agenda);
        this.$refs.personaEdit.nuevo('');
        },

        persona_change(){
          // console.log("persona_change",this.rec.persona);
          if (!this.rec.persona) {
            // console.log("persona vacia")
            //this.rec.persona = null;
            return;
          }
          // console.log("persona_change",this.rec.persona.aviso)
          if (this.rec.persona.aviso && this.rec.persona.aviso!=="") this.mostrarWarning(this.rec.persona.aviso);
          if (this.cargando) return;
          this.rec.persona = new Persona({...this.rec.persona}); //si no lo hago así no me reconoce los métodos de la clase
        },

        async getActosLocal(){
            if (this.sesion.es_medico()) {
              let cod_agenda='';

              if (this.rec.agendaDef) cod_agenda=this.rec.agendaDef.cod;
            // console.log("getActosLocal",this.sesion.es_medico(),this.rec.agendaDef)
              if (cod_agenda) {
                this.actos = await getActos(cod_agenda);
              }
            }
        },
        
        persona_nueva_change(){
          this.sesion.personas.push({...this.persona_nueva});
          this.rec.persona=this.persona_nueva;         
          // console.log("persona_change",this.rec.persona);
          this.rec = new Cita({...this.rec});
          this.recalculaAviso(true);       
        },
        editar_persona() {
          this.$refs.personaEdit.editar(this.rec.persona.cod);
        },


    },

    watch: {

        async agenda (val) {  
            // console.log("watch agenda",val)
            this.getActosLocal();
        },
        nueva_listaEspera(val) {
        // console.log("nueva_listaEspera",val)
            if (val) this.nuevo('');
            this.sesion.nueva_listaEspera = false;
        },
      

    }

 

}

</script>

<style scope>

.margintop_13 {
  margin-top: -10px;
}
.margintop_30 {
  margin-top: -20px;
}


</style>
